import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.goToWaitingLobby.label",
    defaultMessage: "Go to waiting room",
    description: "Button label go to waiting lobby page",
  },
});
